function FeaturePost({data,Link}){
   return(
    <>
    <section className="featured-post pointer-crusser">
        <div className="blog_image_trcak">
        <Link to={`/blog/${data?.top_first?.slug}`}>
            <img src={data?.top_first?.media} alt={data?.top_first?.slug} />
        </Link>
        </div>

        <div className="featured-info">
        <div style={{ position: "relative", top: "4%" }}>
            <div>
            <span className="read-time">3min Read</span>
            </div>
            <div>
            {/* <span className="post-date">Posted on {moment(data?.top_first?.created_at).format("DD MMM YYYY")}</span> */}
            <span className="post-date">
                Posted on{" "}
                {new Date(data?.top_first?.created_at).toLocaleDateString(
                "en-GB",
                {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                }
                )}
            </span>
            </div>
            <div>
            <Link to={`/blog/${data?.top_first?.slug}`}>
                <h2>{data?.top_first?.name}</h2>
            </Link>
            </div>
        </div>
        </div>
    </section>
    </>
   )
}
export default FeaturePost;